__webpack_require__.p = "/Mern1-frontend/";